import { Box, Chip, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { appCardVariants, type AppCardVariant } from "./appCard.variants"

export const AppCardRoot = styled(Box, {
  shouldForwardProp: (prop) => prop !== "cardVariant",
})<{ cardVariant: AppCardVariant }>(({ cardVariant }) => {
  const v = appCardVariants[cardVariant];

  return {
    cursor: "pointer",
    border: "1px solid",
    transition: v.transition,
    padding: v.root.padding,
    borderRadius: v.root.borderRadius,
    borderColor: v.root.borderColor,
    backgroundColor: v.root.backgroundColor,
    "&:hover": {
      boxShadow: v.root.hover.boxShadow,
      transform: v.root.hover.transform,
      borderColor: v.root.hover.borderColor,
    },
  };
});

export const AppIcon = styled("img", {
  shouldForwardProp: (prop) => prop !== "cardVariant",
})<{ cardVariant: AppCardVariant }>(({ cardVariant }) => {
  const v = appCardVariants[cardVariant];
  return {
    width: v.icon.size,
    height: v.icon.size,
    borderRadius: 12,
    padding: 4,
    backgroundColor: v.icon.bg,
    objectFit: "contain",
    objectPosition: "center",
  };
});

export const AppTitle = styled(Typography, {
  shouldForwardProp: (prop) => prop !== "cardVariant",
})<{ cardVariant: AppCardVariant }>(({ cardVariant }) => {
  const v = appCardVariants[cardVariant];
  return {
    fontWeight: 700,
    fontSize: v.title.fontSize,
    color: v.title.color,
  };
});

export const AppDescription = styled(Typography, {
  shouldForwardProp: (prop) => prop !== "cardVariant",
})<{ cardVariant: AppCardVariant }>(({ cardVariant }) => {
  const v = appCardVariants[cardVariant];
  return {
    fontSize: v.description.fontSize,
    color: v.description.color,
    lineHeight: v.description.lineHeight,
    marginBottom: v.description.marginBottom,
  };
});

export const CategoryChip = styled(Chip, {
  shouldForwardProp: (prop) => prop !== "cardVariant",
})<{ cardVariant: AppCardVariant }>(({ cardVariant }) => {
  const v = appCardVariants[cardVariant];

  return {
    textTransform: "capitalize",
    height: 18,
    fontSize: "0.65rem",
    fontWeight: 500,
    borderRadius: 6,
    ...(v.categoryChip.color ? { color: v.categoryChip.color } : {}),
    ...(v.categoryChip.borderColor ? { borderColor: v.categoryChip.borderColor } : {}),
    "& .MuiChip-label": {
      paddingLeft: 6,
      paddingRight: 6,
      paddingTop: 2,
      paddingBottom: 2,
    },
  };
});
